'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ResourcesConstants = void 0;

if (__ENV__ === 'PRODUCTION') {
  ResourcesConstants = {
    DRIFT_API: 'https://driftapi.com',
    ACCOUNTS_API: 'https://account.api.drift.com',
    ATTACHMENTS_API: 'https://attachments.drift-files.com',
    CONVERSATION_API: 'https://conversation.api.drift.com',
    LIVE_API: 'https://audiences.api.drift.com',
    CONVERSATION_CLIENT_API: 'https://api.drift.com/conversation-client',
    INBOX_API: 'https://api.drift.com/inbox',
    CUSTOMER_API: 'https://customer.api.drift.com',
    CONTACTS_API: 'https://contacts.api.drift.com',
    KONG_CUSTOMER_API: 'https://api.drift.com/customer',
    EVENT_API: 'https://event.api.drift.com',
    FILE_API: 'https://file2.api.drift.com',
    GDPR_API: 'https://gdpr.api.drift.com',
    REPORT_API: 'https://report.api.drift.com',
    CLIENT_ID: '5ud8gidk3rp7du',
    KNOWLEDGEBASE_API: 'https://api.driftdocs.com',
    DRIFT_METRICS_API: 'https://metrics.api.drift.com',
    AUTH_API: 'https://api.drift.com/auth',
    ENRICHMENT_API: 'https://enrichment.api.drift.com',
    EMAIL_API: 'https://email.api.drift.com',
    BILLING_API: 'https://api.drift.com/billing',
    INTEGRATION_API: 'https://integration.drift.com',
    ANSWERS_API: 'https://answers.api.drift.com',
    PAGES_API: "https://pages.api.drift.com",
    MESSAGING_API: 'https://messaging.api.drift.com',
    TARGETING_API: 'https://targeting.api.drift.com',
    NOTIFICATIONS_API: 'https://notifications.api.drift.com',
    MEETINGS_API: 'https://meetings.api.drift.com',
    FALCOR_API: 'https://falcor.api.drift.com'
  };
} else {
  ResourcesConstants = {
    DRIFT_API: 'https://driftapiqa.com',
    ACCOUNTS_API: 'https://account.api.driftqa.com',
    ATTACHMENTS_API: 'https://attachments.driftqa-files.com',
    CONVERSATION_API: 'https://conversation2.api.driftqa.com',
    LIVE_API: 'https://audiences.api.driftqa.com',
    CONVERSATION_CLIENT_API: 'https://api.driftqa.com/conversation-client',
    INBOX_API: 'https://api.driftqa.com/inbox',
    CUSTOMER_API: 'https://customer2.api.driftqa.com',
    CONTACTS_API: 'https://contacts.api.driftqa.com',
    KONG_CUSTOMER_API: 'https://api.driftqa.com/customer',
    EVENT_API: 'https://event2.api.driftqa.com',
    FILE_API: 'https://file2.api.driftqa.com',
    GDPR_API: 'https://gdpr.api.driftqa.com',
    REPORT_API: 'https://report.api.driftqa.com',
    CLIENT_ID: 'nwr5icbhx5d4ur',
    KNOWLEDGEBASE_API: 'https://api.driftdocs-qa.com',
    DRIFT_METRICS_API: 'https://metrics.api.driftqa.com',
    AUTH_API: 'https://api.driftqa.com/auth',
    ENRICHMENT_API: 'https://enrichment.api.driftqa.com',
    EMAIL_API: 'https://email.api.driftqa.com',
    BILLING_API: 'https://api.driftqa.com/billing',
    INTEGRATION_API: 'https://integration.driftqa.com',
    ANSWERS_API: 'https://answers.api.driftqa.com',
    PAGES_API: "https://pages.api.driftqa.com",
    MESSAGING_API: 'https://messaging.api.driftqa.com',
    TARGETING_API: 'https://targeting.api.driftqa.com',
    NOTIFICATIONS_API: 'https://notifications.api.driftqa.com',
    MEETINGS_API: 'https://meetings.api.driftqa.com',
    FALCOR_API: 'https://falcor.api.driftqa.com'
  };
}

ResourcesConstants.AUTH_COOKIE_NAME = 'DrifttAuth';
exports.default = ResourcesConstants;
module.exports = exports['default'];